import { render } from "./OrdersExportBtn.vue?vue&type=template&id=7de7d86e&ts=true"
import script from "./OrdersExportBtn.vue?vue&type=script&lang=ts"
export * from "./OrdersExportBtn.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__